import { FormGroup, FormControl, Validators } from '@angular/forms';

// core
import { FlagsHelper } from '../../../core/library/flags-helper';

// own module
import { LytTreeAbstract } from './lyt-tree-abstract';
import { JssNodeLeaf } from './jss-tree-leaf';

export class LytTreeControl extends LytTreeAbstract {

   constructor(
      protected _jssNodeLeaf: JssNodeLeaf
   ) {
      super();
   }

   // Dump
   public reveDumpLytTree(indent: string) {
      console.log(indent + 'Control');
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/lyt-tree-control.ts